export const ADS_PAGE_LEAD =
    "Add who is paying, what they bought, then the picture members will see in the app.";

export const ADS_PATH = [
    { step: "1", tab: "Sponsors", label: "Who is paying" },
    { step: "2", tab: "Deals", label: "What they bought" },
    { step: "3", tab: "Banners", label: "What members see" },
];

export const ADS_TAB_COPY = {
    Sponsors: {
        meaning: "The businesses paying your club.",
        how: "Add a company once. Their name and logo are reused on deals and the logo strip.",
    },
    Deals: {
        meaning: "What each sponsor bought.",
        how: "Pick GOLD, SILVER, or BRONZE. The card below shows where members at this club will see it.",
    },
    Payments: {
        meaning: "Money you collected on a deal.",
        how: "Record a payment after a sponsor pays. This is bookkeeping, not a charge from SportMingle.",
    },
    Banners: {
        meaning: "The picture members see.",
        how: "Upload the ad, pick where it shows, then save. Open Preview to see it on an iPhone.",
    },
    Preview: {
        meaning: "How the ad looks in the SportMingle app.",
        how: "Live banners from the Banners tab — not the companies on Sponsors. The page says what this screen shows and why.",
    },
    Campaigns: {
        meaning: "When the ads run, and the budget.",
        how: "Optional. Set dates and a total budget, then attach banners to this campaign. Edit or delete anytime.",
    },
    Analytics: {
        meaning: "How the ads performed.",
        how: "Views and taps appear after members see ads in the app. Web Preview does not count.",
    },
};

export const ADS_TIER_MATRIX = [
    {
        tier: "GOLD",
        free: "Home carousel, Event, Schedule details, and logo strip",
        plus: "Logo strip only",
    },
    {
        tier: "SILVER",
        free: "Event, Schedule details, and logo strip. Not Home.",
        plus: "Logo strip only",
    },
    {
        tier: "BRONZE",
        free: "Logo strip only",
        plus: "Logo strip only",
    },
    {
        tier: "No deal (club-house)",
        free: "Any slot they pick",
        plus: "Logo strip only",
    },
];

export const ADS_TIER_NOTES = [
    "Logo-strip banners sit in list tiles on Events and Schedule details. The app also puts those ads into the Home carousel.",
    "Home is the top of the Home screen. Only GOLD or a club-house ad can use it, and only on a Free club.",
];

export const ADS_TIER_NOTES_PLUS = [
    "GOLD, SILVER, BRONZE, and club-house ads all show on the logo strip.",
    "Home, Event, and Schedule details ads stay hidden on Plus.",
];

export const tierGuideForPlan = (isFreePlan = true) => {
    if (isFreePlan) {
        return {
            lead: "Where members will see the ad at this Free club.",
            column: "Members see",
            rows: ADS_TIER_MATRIX.map((row) => ({ tier: row.tier, membersSee: row.free })),
            notes: ADS_TIER_NOTES,
        };
    }
    return {
        lead: "Plus members only see the logo strip, no matter the tier.",
        column: "Members see",
        rows: ADS_TIER_MATRIX.map((row) => ({ tier: row.tier, membersSee: row.plus })),
        notes: ADS_TIER_NOTES_PLUS,
    };
};

const countLabel = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

export const previewExplain = ({
    screen = "home",
    ads = [],
    logos = [],
    isFreePlan = true,
} = {}) => {
    const adCount = ads.length;
    const logoCount = logos.length;

    if (screen === "home") {
        if (adCount === 0 && logoCount === 0) {
            return {
                what: "Nothing on Home yet. Save a Home banner or a logo-strip banner on Banners.",
                why: isFreePlan
                    ? "The app Home screen has no bottom logo row. It puts Home ads (at most two) and every logo-strip banner into this carousel. Companies on Sponsors do not appear until they have a logo-strip banner."
                    : "Plus clubs only show sponsor logos. Home ads stay hidden. Companies on Sponsors do not appear until you save a logo-strip banner.",
            };
        }
        if (!isFreePlan) {
            return {
                what: `${countLabel(logoCount, "logo-strip banner", "logo-strip banners")} in the Home carousel. Home ads stay hidden on Plus.`,
                why: "Plus clubs only show sponsor logos. Companies on Sponsors do not appear until you save a logo-strip banner.",
            };
        }
        const parts = [];
        if (adCount) {
            parts.push(countLabel(adCount, "Home ad", "Home ads"));
        }
        if (logoCount) {
            parts.push(countLabel(logoCount, "logo-strip banner", "logo-strip banners"));
        }
        return {
            what: `${parts.join(" and ")} in the Home carousel.`,
            why: "The app Home screen has no bottom logo row. It puts Home ads (at most two) and every logo-strip banner into this carousel. Companies on Sponsors do not appear until they have a logo-strip banner.",
        };
    }

    const place = "Event Details";
    if (!isFreePlan) {
        return {
            what: logoCount
                ? `${countLabel(logoCount, "logo-strip banner", "logo-strip banners")} in the SPONSORS tile. ${place} ads stay hidden on Plus.`
                : `Nothing on this screen yet. Save a logo-strip banner on Banners.`,
            why: "Plus clubs only show sponsor logos. Companies on Sponsors do not appear until you save a logo-strip banner.",
        };
    }
    const parts = [];
    if (adCount) {
        parts.push(countLabel(adCount, `${place} ad`, `${place} ads`));
    }
    if (logoCount) {
        parts.push(`${countLabel(logoCount, "logo-strip banner", "logo-strip banners")} in the SPONSORS tile`);
    }
    return {
        what: parts.length
            ? parts.join(", plus ")
            : `Nothing on this screen yet. Save a ${place} banner or a logo-strip banner on Banners.`,
        why: "This matches Event Details in the app: banners show a short title and * This is an ad, and logo-strip ads sit under SPONSORS.",
    };
};
